import React from "react";
import { supabase } from "./client";


export const FLOW = [
  "BlackoutKnowledgeQuestion",
  "AwarenessIntro",
  "ThreatPerceptionQuestion",
  "OthersSaid",
  "StayOrLeave",
  "StayDecision",
  "PrepareYourself",
  "ScenarioPowerOutage",
  "ScenarioBurningBuilding",
  "ScenarioSecuringDocuments",
  "ScenarioEmergency",
  "ScenarioRecoveryPosition",
  "ScenarioCommunicationFailure",
  "ScenarioSirene",
  "ScenarioCrisis",
  "ScenarioOrientation",
  "ScenarioInformationOverload",
  "ScenarioMentalOverwhelm",
  "ScenarioIsolation",
  "ScenarioEvacuation",
  "EvacuationTaskReview",
  "ScenarioPhysicalLimit",
  "ShareStateScreen",
  "FamilyPreparedness",
  "CommunityPreparedness",
  "AvailabilityAwareness",
  "AvailabilityCheck",
  "EmployeeScreen",
  "TakeAPhoto",
  "ShareInvitation",
  "N/A",
];

export function useWorkshopBlocker() {
  const [currentScreen, setCurrentScreen] = React.useState<string>("BlackoutKnowledgeQuestion");

  React.useEffect(() => {
    let channel: any;

    async function init() {
      const { data } = await supabase
        .from("workshops")
        .select("id")
        .eq("is_active", true)
        .single();

      if (!data) return;

      const workshopId = data.id;

      const { data: state } = await supabase
        .from("workshop_live_state")
        .select("current_screen")
        .eq("workshop_id", workshopId)
        .single();

      if (state?.current_screen) {
        setCurrentScreen(state.current_screen);
      }

      channel = supabase
        .channel("workshop-live")
        .on(
          "postgres_changes",
          {
            event: "*",
            schema: "public",
            table: "workshop_live_state",
            filter: `workshop_id=eq.${workshopId}`,
          },
          (payload) => {
            setCurrentScreen((payload.new as { current_screen: string }).current_screen);
          }
        )
        .subscribe();
    }

    init();

    return () => {
      if (channel) supabase.removeChannel(channel);
    };
  }, []);

  return currentScreen;
}

export function getNextScreen(current: string) {
  const index = FLOW.indexOf(current);
  return FLOW[index + 1] ?? current;
}